import { useCallback, useEffect, useState } from "react";
import { getInstitution } from "../../services/customerTouchPoint";

const useInstitution = () => {
    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await getInstitution();

        if (res.data.code === "0000") {
            setData(res.data.objectValue);
        }
    }, [setData]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data];
};

export default useInstitution;
